import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withLookup$1 from '../../cinnamon-core/es/components/lookups/withLookup.js';
import { compareParams } from '../../cinnamon-core/es/modules/utility/params.js';
import ComboBox from './base/ComboBox.js';
import { getLookupData } from '../../cinnamon-core/es/modules/lookups/selectors.js';
import { lookupRequest } from '../../cinnamon-core/es/modules/lookups/actions.js';

var _excluded = ["lookup", "lookupAction", "lookupParams", "lookupOptions", "lookupData", "lookupRequest", "requestLookupWhenDisabled", "ref"];

var DropdownBase = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownBase, _React$Component);

  var _super = _createSuper(DropdownBase);

  function DropdownBase() {
    var _this;

    _classCallCheck(this, DropdownBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_requestRequired", false);

    _defineProperty(_assertThisInitialized(_this), "canRequestData", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          requestLookupWhenDisabled = _this$props.requestLookupWhenDisabled;
      return !disabled || requestLookupWhenDisabled;
    });

    _defineProperty(_assertThisInitialized(_this), "isLoading", function () {
      var _this$props2 = _this.props,
          lookup = _this$props2.lookup,
          lookupData = _this$props2.lookupData,
          loading = _this$props2.loading;
      if (!lookup) return loading;
      return lookupData.loading && lookupData.slowLoading;
    });

    _defineProperty(_assertThisInitialized(_this), "getOptions", function () {
      var _this$props3 = _this.props,
          lookup = _this$props3.lookup,
          lookupData = _this$props3.lookupData,
          options = _this$props3.options;
      if (!lookup) return options !== null && options !== void 0 ? options : [];
      return Array.isArray(lookupData.response) ? lookupData.response : [];
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props4 = _this.props,
          lookupRequest = _this$props4.lookupRequest,
          lookup = _this$props4.lookup,
          lookupParams = _this$props4.lookupParams,
          lookupOptions = _this$props4.lookupOptions,
          lookupData = _this$props4.lookupData;

      var canRequestData = _this.canRequestData(); // re-request if lookup was reset, params changed, or was flagged


      if (lookup && (lookup !== prevProps.lookup || !lookupData.date && prevProps.lookupData.date || !compareParams(lookupParams, prevProps.lookupParams) || canRequestData && _this._requestRequired)) {
        if (!canRequestData) {
          // flag that lookup data should be retrieved when the component is re-enabled
          _this._requestRequired = true;
          return;
        }

        _this._requestRequired = false;
        lookupRequest(lookup, lookupParams, lookupOptions);
      }
    });

    return _this;
  }

  _createClass(DropdownBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
          lookupRequest = _this$props5.lookupRequest,
          lookup = _this$props5.lookup,
          lookupParams = _this$props5.lookupParams,
          lookupOptions = _this$props5.lookupOptions;
      if (!lookup) return;

      if (!this.canRequestData()) {
        // flag that lookup data should be retrieved when the component is re-enabled
        this._requestRequired = true;
        return;
      }

      lookupRequest(lookup, lookupParams, lookupOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props;
          _this$props6.lookup;
          _this$props6.lookupAction;
          _this$props6.lookupParams;
          _this$props6.lookupOptions;
          _this$props6.lookupData;
          _this$props6.lookupRequest;
          _this$props6.requestLookupWhenDisabled;
          _this$props6.ref;
          var otherProps = _objectWithoutProperties(_this$props6, _excluded);

      var loading = this.isLoading();
      var options = this.getOptions();
      return /*#__PURE__*/React.createElement(ComboBox, _extends({}, otherProps, {
        loading: loading,
        options: options
      }));
    }
  }]);

  return DropdownBase;
}(React.Component);

_defineProperty(DropdownBase, "propTypes", {
  options: propTypes.any,
  requestLookupWhenDisabled: propTypes.bool,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any,
  lookupData: propTypes.any.isRequired,
  lookupRequest: propTypes.func.isRequired
});

var mapStateToProps = function mapStateToProps(state, _ref) {
  var lookup = _ref.lookup,
      lookupParams = _ref.lookupParams,
      lookupOptions = _ref.lookupOptions;
  return {
    lookupData: lookup ? getLookupData(state, lookup, lookupParams, lookupOptions) : {
      loading: false,
      slowLoading: false
    }
  };
};

var actions = {
  lookupRequest: lookupRequest
};

var connectBase = function connectBase() {
  return connect(mapStateToProps, actions);
};

var DropdownBaseComponent = compose(withLookup$1({
  autoNamePrefix: "LookupDropdown/",
  required: false
}), connectBase())(DropdownBase);
/**
 * Wrapper around MUI Autocomplete with optional lookup data connectivity in the form of a list of selectable options
 */

var Dropdown = function Dropdown(props) {
  return /*#__PURE__*/React.createElement(DropdownBaseComponent, props);
};

Dropdown.propTypes = {
  options: propTypes.any,
  requestLookupWhenDisabled: propTypes.bool,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any
};
Dropdown.defaultProps = {
  search: false,
  requestLookupWhenDisabled: false
};
var IDropdown = Dropdown;

export { IDropdown as default };
